export const HeroPlan=[
    'Squad Play & Solo Play',
    'Unlock the Challenge Library',
    'Customize your journey',

] 